import { InjectionToken, Provider } from '@angular/core';
import { CommunityApiConfig } from '../interfaces/api/internal-api';

export const COMMUNITY_API_PROVIDER = new InjectionToken<CommunityApiConfig>('COMMUNITY_API_PROVIDER');

export const provideCommunityApi = (baseUrl: string): Provider[] => {
  return [
    {
      provide: COMMUNITY_API_PROVIDER,
      useValue: buildCommunityApiConfig(baseUrl || '/api'),
    },
  ];
};

function buildCommunityApiConfig(baseUrl: string): CommunityApiConfig {
  return {
    postUrl: `${baseUrl}/posts`,
    videoUrl: `${baseUrl}/client/video`,
    externalVideoUrl: `${baseUrl}/external/video`,
    ownerUrl: `${baseUrl}/passport`,
    followersUrl: `${baseUrl}/followers`,
    followGroup: `${baseUrl}/followers/objects`,
    userUrl: `${baseUrl}/auth/user`,
    selectionsUrl: `${baseUrl}/posts/selections`,
    filesUrl: `${baseUrl}/files`,
  };
}
